var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisibilityOnIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3906 4.87943C7.70462 4.87943 4.55675 7.17213 3.28139 10.4085C4.55675 13.6448 7.70462 15.9375 11.3906 15.9375C15.0767 15.9375 18.2245 13.6448 19.4999 10.4085C18.2245 7.17213 15.0767 4.87943 11.3906 4.87943ZM11.3906 14.0945C9.35596 14.0945 7.70462 12.4431 7.70462 10.4085C7.70462 8.37378 9.35596 6.72244 11.3906 6.72244C13.4253 6.72244 15.0767 8.37378 15.0767 10.4085C15.0767 12.4431 13.4253 14.0945 11.3906 14.0945ZM11.3906 8.19685C10.1669 8.19685 9.17903 9.1847 9.17903 10.4085C9.17903 11.6322 10.1669 12.6201 11.3906 12.6201C12.6144 12.6201 13.6023 11.6322 13.6023 10.4085C13.6023 9.1847 12.6144 8.19685 11.3906 8.19685Z",
    fill: "#04B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibilityOnIcon);
export default __webpack_public_path__ + "static/media/VisibilityOnIcon.591ab6cd498a97d70c4a27f07ee2ff4a.svg";
export { ForwardRef as ReactComponent };